/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
// import { textMatcher } from '../../../../../SharedModules/utilities/utilities';
import {
  textMatcher,
  cellRenderer,
  comparatorQtr,
} from '../../../../SharedModules/utilities/utilities';

export const AllAdjustmentGrid = [
  {
    headerName: 'Select All',
    // minWidth: Styles.Width_50,
    headerCheckboxSelection: true, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: true,
    maxWidth: 135,
    checkboxSelection: true,
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Reason Code',
    field: 'codeValue',
    editable: false,
    suppressMenu: false,
    sort: 'asc',
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    // autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'longDescription',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',

    wrapText: true,
    // autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

// Object to map which adjustement should have which columns
export const mapping = {
  R: ['adjustTypeCd', 'mfgName', 'targetQtr', 'URAC', 'URCA', 'URAL', 'total'],
  W: ['adjustTypeCd', 'mfgName', 'targetQtr', 'WOFF', 'DBAL', 'FRGV', 'total'],
  I: ['adjustTypeCd', 'mfgName', 'targetQtr', 'IOAR', 'IDBL', 'total'],
  X: ['adjustTypeCd', 'mfgName', 'targetQtr', 'ICLC', 'IDBU', 'total'],
  U: [
    'adjustTypeCd',
    'mfgName',
    'targetQtr',
    'UACD',
    'UACM',
    'UAAR',
    'UCCN',
    'UOCR',
    'UOMR',
    'total',
  ],
  T: ['adjustTypeCd', 'mfgName', 'targetQtr', 'DBUP', 'total'],
};

// All columns for table
export const AdjustmentReasonCodeTableHead = [
  {
    headerName: 'Adjustment Type',
    field: 'adjustTypeCd',
    editable: false,
    suppressMenu: false,
    sortable: false,
    minWidth: Styles.Width_171,
    cellRenderer: 'GenericCodeTextBox',
    sortingOrder: ['desc', 'asc'],
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapHeaderText: true,
    autoHeaderHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    columnSpan: 3,
    sortable: true,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_300,
    // maxWidth: Styles.Width,
    comparator: () => {},
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'TextBoxRender',
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Qtr',
    field: 'targetQtr',
    editable: false,
    suppressMenu: false,
    sortable: false,
    minWidth: Styles.Width_200,
    wrapText: true,
    comparator: comparatorQtr,
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellRenderer: function (params) {
      if (params.data.isBottomRow) {
        return '';
      }
      if (params.value === 'Total') {
        return <span style={{ fontWeight: 'bold' }}>{params.value}</span>;
      }
      return params.value;
    },
    // custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'URAC',
    field: 'URAC',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    sortable: false,

    custClass: 'tbill-rate-editable-input',
    minWidth: Styles.Width_150,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'URCA',
    field: 'URCA',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'URAL',
    field: 'URAL',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    resizable: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'WOFF',
    field: 'WOFF',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'DBAL',
    field: 'DBAL',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'FRGV',
    field: 'FRGV',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'IOAR',
    field: 'IOAR',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcher,
    },
    isAmount: true,
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'IDBL',
    field: 'IDBL',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'ICLC',
    field: 'ICLC',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'IDBU',
    field: 'IDBU',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },

  {
    headerName: 'UACD',
    field: 'UACD',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    // cellRenderer: ragRenderer,
    // cellRenderer,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',

    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'UACM',
    field: 'UACM',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'UAAR',
    field: 'UAAR',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'UCCN',
    field: 'UCCN',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'UOCR',
    field: 'UOCR',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'UOMR',
    field: 'UOMR',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
  {
    headerName: 'DBUP',
    field: 'DBUP',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    // autoHeight: true,
    sortable: false,
    isTextColorRed: true,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isAmount: true,
  },
  {
    headerName: 'Total',
    field: 'total',
    editable: false,
    suppressMenu: false,
    sortable: false,
    // printPrefixValue: '$',
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    // cellRenderer,
    minWidth: Styles.Width_150,
    wrapText: true,
    // autoHeight: true,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
    isAmount: true,
  },
];

// Function to filter columns from all columns as required by adjustment code
export const getRequiredColumn = (name, value) => {
  return AdjustmentReasonCodeTableHead.filter((item) => {
    if (item?.removeColumn && !value) {
      return item;
    }
    return mapping[name]?.indexOf(item.field) != '-1';
  });
};

export const getRequiredColumnOnExportPDF = (name, value, columnApi) => {
  const colDisplayArray = columnApi.getAllDisplayedColumns()?.map((prop) => {
    return { ...prop, ...prop.colDef };
  });
  return colDisplayArray.filter((item) => {
    if (item?.colDef?.removeColumn && !value) {
      return item;
    }
    return mapping[name]?.indexOf(item?.colDef?.field) != '-1';
  });
};
